import { countBy, flatten, max, round, sum } from "lodash"

import { filterNotUndefinedOrNull, uniq } from "~/utils/tsUtils"

export const aggregators = {
  sum: (values: (number | null | undefined)[]) => {
    const realValues = values.filter((value) => !(value === null || value === undefined))
    if (realValues.length) {
      return sum(realValues)
    } else {
      return null
    }
  },
  average: (values: (number | null | undefined)[]) => {
    const realValues = values.filter((value) => !(value === null || value === undefined))
    if (realValues.length) {
      const summed = sum(realValues)
      return round(summed / realValues.length, 1)
    } else {
      return null
    }
  },
  min: (values: (number | Date | null)[]) =>
    filterNotUndefinedOrNull(values).sort((a, b) => (a > b ? 1 : -1))[0] ?? null,
  none: (value: any) => value, // Only use if the selector is also the aggregator
  unique: (values: any[]) => uniq(flatten(values).filter(Boolean)).sort((a, b) => (a > b ? 1 : -1)),
  mode: (values: any[]) => {
    // Which value occurs most often
    const counts = countBy(values.filter(Boolean))
    const highest = max(Object.values(counts))
    return Object.keys(counts).find((key) => counts[key] === highest)
  },
}
